import React from "react";
import { FontAwesomeIcon } from "../../../../../../CommonComponents/AssetsHelper";

const CATEGORY_ICONS = {
    1: (isActive) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 40 40">
            <g transform="translate(3494 -21353.195)">
                <rect width="13" height="22" rx="1" transform="translate(-3494 21353.195)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="17" rx="1" transform="translate(-3466 21353.195)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="11" height="14" rx="1" transform="translate(-3479 21353.195)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="11" height="24" rx="1" transform="translate(-3479 21369.195)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="11" rx="1" transform="translate(-3466 21372.195)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="13" height="16" rx="1" transform="translate(-3494 21377.195)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="8" rx="1" transform="translate(-3466 21385.195)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
            </g>
        </svg>
    ),
    2: (isActive) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 40 40">
            <g transform="translate(3763 -21659.227)">
                <rect width="12" height="12" rx="1" transform="translate(-3763 21659.227)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="12" rx="1" transform="translate(-3749 21659.227)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="12" rx="1" transform="translate(-3735 21659.227)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="12" rx="1" transform="translate(-3763 21673.227)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="12" rx="1" transform="translate(-3749 21673.227)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="12" rx="1" transform="translate(-3735 21673.227)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="12" rx="1" transform="translate(-3763 21687.227)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="12" rx="1" transform="translate(-3749 21687.227)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="12" height="12" rx="1" transform="translate(-3735 21687.227)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
            </g>
        </svg>
    ),
    3: (isActive) => (
        <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.1738 16H4.17383C3.62154 16 3.17383 16.4477 3.17383 17V27C3.17383 27.5523 3.62154 28 4.17383 28H12.1738C12.7261 28 13.1738 27.5523 13.1738 27V17C13.1738 16.4477 12.7261 16 12.1738 16Z" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
            <path d="M24.1992 16H16.1992C15.6469 16 15.1992 16.4477 15.1992 17V27C15.1992 27.5523 15.6469 28 16.1992 28H24.1992C24.7515 28 25.1992 27.5523 25.1992 27V17C25.1992 16.4477 24.7515 16 24.1992 16Z" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
            <path d="M36.2246 16H28.2246C27.6723 16 27.2246 16.4477 27.2246 17V27C27.2246 27.5523 27.6723 28 28.2246 28H36.2246C36.7769 28 37.2246 27.5523 37.2246 27V17C37.2246 16.4477 36.7769 16 36.2246 16Z" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
            <path d="M1.80371 24.0493L0.00390625 21.9888L0.0908203 21.8892L1.80762 19.9517C1.83597 19.9192 1.87105 19.8936 1.91016 19.8755C1.94927 19.8574 1.99158 19.8468 2.03467 19.8462C2.07997 19.8466 2.12447 19.8583 2.16553 19.8774C2.20658 19.8966 2.24351 19.9231 2.27295 19.9575V19.9634C2.32572 20.0316 2.35363 20.1174 2.35254 20.2036C2.35145 20.2899 2.32108 20.3731 2.2666 20.4399L0.879883 21.9946L2.2666 23.561C2.32012 23.63 2.34912 23.714 2.34912 23.8013C2.34912 23.8885 2.32012 23.9726 2.2666 24.0415C2.23838 24.0757 2.2032 24.1047 2.16309 24.1235C2.12297 24.1424 2.07899 24.151 2.03467 24.1509C1.99119 24.1515 1.94804 24.1429 1.9082 24.1255C1.86836 24.1081 1.83279 24.0816 1.80371 24.0493Z" fill={isActive ? "#FFFFFF" : "#959595"} />
            <path d="M38.1363 24.0278C38.08 23.9623 38.0489 23.8799 38.0489 23.7935C38.0489 23.707 38.08 23.6226 38.1363 23.5571L39.5172 21.9849L38.1363 20.436C38.0796 20.3705 38.0472 20.2883 38.045 20.2017C38.0429 20.115 38.0708 20.0297 38.1241 19.9614C38.1528 19.9257 38.189 19.8957 38.2301 19.8755C38.2712 19.8553 38.3161 19.8442 38.3619 19.8442C38.4064 19.8444 38.4507 19.8543 38.4908 19.8735C38.531 19.8927 38.5663 19.921 38.5944 19.9556L40.3942 21.9849L40.3072 22.0845L38.589 24.0396C38.5298 24.1013 38.449 24.1369 38.3634 24.1392C38.3196 24.1395 38.2758 24.1291 38.2364 24.1099C38.1971 24.0906 38.163 24.0627 38.1363 24.0278Z" fill={isActive ? "#FFFFFF" : "#959595"} />
        </svg>
    ),
    4: (isActive) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 40 40">
            <g transform="translate(3494 -21353.195)">
                <rect width="19" height="40" rx="1" transform="translate(-3494 21353.195)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
                <rect width="19" height="40" rx="1" transform="translate(-3473 21353.195)" fill={isActive ? "#FFFFFF" : "#D0D5DD"} />
            </g>
        </svg>
    )
};

const getCategoryLabel = (layout) => {
    if (layout.index === 1 || layout.layout === "Masonry") return "Waterfall";
    if (layout.index === 2 || layout.layout === "Grid") return "Grid Layout";
    if (layout.index === 3 || layout.layout === "Carousel") return "Carousel";
    if (layout.index === 4 || layout.layout === "Slideshow") return "Slideshow";
    return `${layout.layout} Layout`;
};

class ThemeLayouts extends React.Component {
    state = { applying: false, activeLayoutIndex: null }

    componentDidMount() {
        this.syncActiveCategory();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.wallData?.wall?.Personalization?.ThemeRule?.themeId !== this.props.wallData?.wall?.Personalization?.ThemeRule?.themeId) {
            this.syncActiveCategory();
        }
    }

    syncActiveCategory = () => {
        const { wallData } = this.props;
        const themeId = wallData?.wall?.Personalization?.ThemeRule?.themeId;
        const themeData = wallData?.themeData;
        if (themeId && themeData?.length > 0) {
            const currentThemeLayout = themeData.find(layout => layout.theme.some(theme => theme.id == themeId));
            if (currentThemeLayout) {
                this.setState({ activeLayoutIndex: currentThemeLayout.index });
            }
        }
    }

    onToggleCategory = (layoutIndex) => {
        this.setState(prevState => ({
            activeLayoutIndex: prevState.activeLayoutIndex === layoutIndex ? null : layoutIndex
        }));
    }

    onSelectTheme = (selectedThemeId) => {
        const { wallData, dispatch, changeOnboardingTheme } = this.props;
        const currentThemeId = wallData?.wall?.Personalization?.ThemeRule?.themeId;
        if (selectedThemeId == currentThemeId || this.state.applying) return;
        this.setState({ applying: selectedThemeId });
        changeOnboardingTheme({ wallData, themeToApply: selectedThemeId, dispatch }, () => this.setState({ applying: false }), false);
    }

    render() {
        const { wallData, onClose, onPublish } = this.props;
        const themeId = wallData?.wall?.Personalization?.ThemeRule?.themeId;
        const themeData = wallData?.themeData;
        if (!themeId || !(themeData?.length > 0)) return null;

        const currentThemeLayout = themeData.find(layout => layout.theme.some(theme => theme.id == themeId));
        const activeLayoutIndex = this.state.activeLayoutIndex !== null ? this.state.activeLayoutIndex : (currentThemeLayout?.index || 1);
        const { applying } = this.state;

        return (
            <div className="ob-theme-panel-drawer">
                {applying ? (
                    <div className="ob-theme-loader-bar">
                        <div className="ob-theme-loader-fill"></div>
                    </div>
                ) : null}

                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h5 className="mb-0 fw-bold text-dark fs-4">Theme Layouts</h5>
                    <span className="cursor-pointer text-dark fs-5" onClick={onClose}><FontAwesomeIcon type={'solid'} icon={'xmark'} /></span>
                </div>

                <div className="ob-theme-categories-list mb-4">
                    {themeData.map((layout) => {
                        const isActiveCategory = layout.index == activeLayoutIndex;

                        return (
                            <div key={layout.index} className={`ob-theme-active-block ${isActiveCategory ? 'is-open' : ''}`}>
                                <div
                                    className={`ob-theme-category-header-active cursor-pointer ${isActiveCategory ? '' : 'is-collapsed'} ${applying ? 'disabled' : ''}`}
                                    onClick={() => { if (!applying) this.onToggleCategory(layout.index); }}
                                >
                                    <div className="ob-theme-category-icon me-2">
                                        {CATEGORY_ICONS[layout.index] ? CATEGORY_ICONS[layout.index](isActiveCategory) : null}
                                    </div>
                                    <h6>{getCategoryLabel(layout)}</h6>
                                </div>

                                <div className={`ob-theme-subgrid-wrap ${isActiveCategory ? 'open' : ''}`}>
                                    <div className="ob-theme-subgrid">
                                        {layout.theme.filter(theme => theme.name?.trim().toLowerCase() !== 'flux').map(theme => {
                                            const isSelected = theme.id == themeId;
                                            const isApplyingThis = applying === theme.id;
                                            return (
                                                <button
                                                    type="button"
                                                    key={theme.id}
                                                    disabled={isSelected || !!applying}
                                                    className={`ob-theme-subtile ${isSelected ? 'active' : ''} ${isApplyingThis ? 'applying' : ''}`}
                                                    onClick={() => this.onSelectTheme(theme.id)}
                                                >
                                                    {isApplyingThis ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2 text-pink" role="status" aria-hidden="true"></span>
                                                            <span>Applying...</span>
                                                        </>
                                                    ) : (
                                                        theme.name
                                                    )}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <button type="button" className="ob-btn-gradient w-100 mt-auto" onClick={onPublish} disabled={!!applying}>Publish</button>
            </div>
        );
    }
}

export default ThemeLayouts;
